module.exports = __webpack_public_path__ + "static/media/box2.8751a623.jpg";